export class BinderAssembly {
    Name: string = '';
    CategoryID: number = 0;
    Description: string = '';
    Price: number | null = null;
    Quantity: number | null = null;
    Type: string = '';
    AID: number | null = null;
    BinderID: number = 0;
    BAID: number = 0;
    CategoryName: string | null = null;
    PrintOrder: number = 0;
    Attach?: boolean = false;
    ATTID?: number = 0;
    Altered?: boolean = false;
    SuperAssemblyID?: number = 0;
    TaxFree: boolean = false;
    editing?: boolean = false;
    Categories: {
        Name: string,
        Sequence: number,
        CategoryID?: number
    } = {
        Name: '',
        Sequence: 0,
        CategoryID: 0
    };
    haId?: string = '';
    hidden?: boolean = false;

    constructor(data: Partial<BinderAssembly>) {
        Object.assign(this, data);

    }
}
